import { windowUtils } from '../windowUtils/windowUtils';

const composeUrl = () => {
  const port = windowUtils.getPort();
  const protocol = windowUtils.getProtocol();
  const hostname = windowUtils.getHostname();
  const url = `${protocol}//${hostname}`;

  if (port) {
    return `${url}:${port}`;
  }

  return url;
};

const getCurrentUrl = () => windowUtils.getOrigin() || composeUrl();
const getDomainName = () => {
  const hostName = windowUtils.getHostname();
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
  );
};

const url = { getCurrentUrl, getDomainName };

export { url };
